import m from 'mithril';
import '@awesome.me/webawesome/dist/components/spinner/spinner.js';

/**
 * Loading indicator attrs.
 */
export interface LoadingAttrs extends m.Attributes {
  /** Large loading state. */
  large?: boolean;
  /** Additional CSS class names. */
  className?: string;
}

/**
 * Renders a Webawesome spinner.
 */
export const Loading: m.Component<LoadingAttrs> = {
  view: ({ attrs }) => {
    return m('div', {
      class: [
        'loading',
        attrs.large ? 'loading--large' : '',
        attrs.className ?? '',
      ].filter(Boolean).join(' '),
      role: 'status',
      'aria-label': 'Loading',
    }, m('wa-spinner'));
  },
};
